// Layout.js
import Button from 'components/Button';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdContacts, MdDashboard } from 'react-icons/md';
import { FaImages, FaListAlt, FaCalendarAlt, FaUsers, FaQuestionCircle } from 'react-icons/fa';
import logo from '../asserts/dev.png'

const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const audioRef = useRef(null);

  const currentUrl = location.pathname;
  const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

  // Toggle sidebar menu
  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  // Logout handler
  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch(logout());
      navigate('/signin');
    } catch (e) {
      console.log(e);
    }
  };

  // Close dropdowns and sidebar on route change
  useEffect(() => {
    setOpenMenu(null);
    setToggle(false);
  }, [location.pathname]);

  // Socket listener removed
  useEffect(() => {
    // Left empty
  }, []);


  return (
    <div id="wrapper">
      {/* eslint-disable jsx-a11y/media-has-caption  */}
      <audio
        ref={audioRef}
        src="https://assets.mixkit.co/active_storage/sfx/933/933-preview.mp3"
        preload="auto"
      />

      <ul
        className={toggled ? 'navbar-nav sidebar sidebar-dark toggled' : 'navbar-nav sidebar sidebar-dark accordion'}
        id="accordionSidebar"
      >
        {/* Mobile Close Button */}
        <div className="d-md-none text-right pr-3 pt-3">
          <button 
            className="btn btn-link text-white" 
            onClick={() => setToggle(false)}
            style={{ fontSize: '24px', textDecoration: 'none' }}
          >
            &times;
          </button>
        </div>
        <Link className="text-decoration-none d-flex align-items-center justify-content-center py-3" to="/dashboard">
          <div className="bg-white p-2 d-flex align-items-center justify-content-center" style={{ width: "130px", height: "130px", overflow: "hidden", borderRadius: "12px", boxShadow: "0 4px 6px rgba(0,0,0,0.15)" }}>
            <img
              src={logo}
              alt="Jawahar R-ABI Logo"
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
            />
          </div>
        </Link>


        {/* Dashboard */}
        <li className="nav-item">
          <Link className="nav-link " to="/dashboard">
            <MdDashboard className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Dashboard</span>
          </Link>
        </li>
        {/* Startups */}
        <li className={`nav-item ${lastSegment === 'startups' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/startups" style={{ color: 'black' }}>
            <FaUsers className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Startups Directory</span>
          </Link>
        </li>

        {/* Mentors (Hidden as per request)
        <li className={`nav-item ${lastSegment === 'mentors' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/mentors" style={{ color: 'black' }}>
            <TbUserSquare className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Mentor Directory</span>
          </Link>
        </li>
        */}

        {/* Team Members */}
        <li className={`nav-item ${lastSegment === 'team' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/team" style={{ color: 'black' }}>
            <FaUsers className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Team Members</span>
          </Link>
        </li>

        {/* Programs */}
        <li className={`nav-item ${lastSegment === 'programs' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/programs" style={{ color: 'black' }}>
            <FaListAlt className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Programs</span>
          </Link>
        </li>

        {/* Events */}
        <li className={`nav-item ${currentUrl.startsWith('/events') ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('events')}
            style={{ color: 'black' }}
          >
            <FaCalendarAlt className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Events</span>
          </Link>
          <div className={`collapse ${openMenu === 'events' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Categories:</h6>
              <Link className="collapse-item text-dark" to="/events/categories/add">
                Add Category
              </Link>
              <Link className="collapse-item text-dark" to="/events/categories">
                Manage Categories
              </Link>
              <h6 className="collapse-header">Files:</h6>
              <Link className="collapse-item text-dark" to="/events/files/add">
                Upload PDF
              </Link>
              <Link className="collapse-item text-dark" to="/events/files">
                Manage Files
              </Link>
            </div>
          </div>
        </li>

        {/* News & Announcements (Hidden as per request)
        <li className={`nav-item ${lastSegment === 'news' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/news" style={{ color: 'black' }}>
            <FaNewspaper className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">News & Notices</span>
          </Link>
        </li>
        */}

        {/* Success Stories (Hidden as per request)
        <li className={`nav-item ${lastSegment === 'stories' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/stories" style={{ color: 'black' }}>
            <FaAward className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Success Stories</span>
          </Link>
        </li>
        */}

        {/* Banner */}
        <li className={`nav-item ${lastSegment === 'banner' ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('banner')}
            style={{ color: 'black' }}
          >
            <FaImages className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Banners</span>
          </Link>
          <div className={`collapse ${openMenu === 'banner' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/banner/add">
                Add Banner
              </Link>
              <Link className="collapse-item text-dark" to="/banner">
                Banner List
              </Link>
            </div>
          </div>
        </li>

        {/* Downloads */}
        <li className={`nav-item ${currentUrl.startsWith('/downloads') ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('downloads')}
            style={{ color: 'black' }}
          >
            <i className="fa fa-download mr-1" style={{ fontSize: '18px' }}></i>
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Downloads</span>
          </Link>
          <div className={`collapse ${openMenu === 'downloads' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Categories:</h6>
              <Link className="collapse-item text-dark" to="/downloads/categories/add">
                Add Category
              </Link>
              <Link className="collapse-item text-dark" to="/downloads/categories">
                Manage Categories
              </Link>
              <h6 className="collapse-header">Files:</h6>
              <Link className="collapse-item text-dark" to="/downloads/files/add">
                Upload PDF
              </Link>
              <Link className="collapse-item text-dark" to="/downloads/files">
                Manage Files
              </Link>
            </div>
          </div>
        </li>

        {/* FAQ */}
        <li className={`nav-item ${currentUrl.startsWith('/faq-files') ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/faq-files" style={{ color: 'black' }}>
            <FaQuestionCircle className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">FAQ</span>
          </Link>
        </li>

        {/* Gallery */}
        <li className={`nav-item ${currentUrl.startsWith('/gallery') ? 'active' : ''}`}>
          <Link
            className="nav-link text-dark collapsed"
            href="#"
            onClick={() => toggleMenu('gallery')}
            style={{ color: 'black' }}
          >
            <FaImages className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Gallery</span>
          </Link>
          <div className={`collapse ${openMenu === 'gallery' ? 'show' : ''}`}>
            <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item text-dark" to="/gallery/add">
                Add Image
              </Link>
              <Link className="collapse-item text-dark" to="/gallery">
                Image List
              </Link>
              <Link className="collapse-item text-dark" to="/gallery/video/add">
                Add Video
              </Link>
              <Link className="collapse-item text-dark" to="/gallery/video">
                Video List
              </Link>
            </div>
          </div>
        </li>

        {/* Contact Us */}
        <li className={`nav-item ${lastSegment === 'contactus' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/contactus" style={{ color: 'black' }}>
            <MdContacts className="mr-1" size={20} />
            <span style={{ fontSize: "16px" }} className="font-weight-bold">Enquiries</span>
          </Link>
        </li>

        {/* QR Visitors */}
        <li className={`nav-item ${lastSegment === 'qr-visitors' ? 'active' : ''}`}>
          <Link className="nav-link text-dark" to="/qr-visitors" style={{ color: 'black' }}>
            <i className="fa fa-qrcode mr-1" style={{ fontSize: "20px" }}></i>
            <span style={{ fontSize: "16px" }} className="font-weight-bold">QR Visitors</span>
          </Link>
        </li>

        {/* Sidebar toggle */}
        <div className="text-center text-dark d-none d-md-inline mt-5">
          <button
            className="rounded-circle border-0 text-dark"
            id="sidebarToggle"
            onClick={() => setToggle(!toggled)}
          ></button>
        </div>
      </ul>

      {/* Content */}
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <nav className="navbar navbar-expand topbar mb-4 static-top shadow" style={{ background: '#015198', borderBottom: '2px solid rgba(255,255,255,0.1)' }}>
            <button
              id="sidebarToggleTop"
              onClick={() => setToggle(!toggled)}
              className="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i className="fa fa-bars" style={{ color: '#ffffff' }}></i>
            </button>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item dropdown no-arrow">
                <Link
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="mr-2 d-none d-lg-inline small font-weight-bold" style={{ color: '#ffffff', letterSpacing: '0.5px' }}>Admin</span>
                  <IoPersonCircleSharp size={28} style={{ color: '#ffffff' }} />
                </Link>
                <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                  <div className="dropdown-divider"></div>
                  <Button className="dropdown-item" text="Logout" onclickfun={logoutHandler} />
                </div>
              </li>
            </ul>
          </nav>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
